var blockquote_default = {
  "fontElementMap": "bYPgs",
  "quote": "Jvj75"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
